export const shippingColumns = [
  {
    id: "number",
    label: "Number",
    editable: false,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "tracking_number",
    label: "Tracking Number",
    editable: false,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "type",
    label: "Type",
    editable: false,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "tickets",
    label: "Tickets",
    editable: true,
    sortable: false,
    type: "multiSelect",
    width: "350",
    show: true,
    resizable: true,
  },
  {
    id: "customer",
    label: "Customer",
    editable: false,
    type: "text",
    width: "250",
    show: true,
    resizable: true,
  },
  {
    id: "contact",
    label: "Contact",
    editable: false,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "created_at",
    label: "Created",
    editable: false,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "updated_at",
    label: "Updated",
    editable: false,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
];
